var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackOrangeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.298136 6.67675C-0.0993804 7.15183 -0.0993804 7.86446 0.298136 8.33955L5.6646 14.6344C6.59213 15.743 8.01656 14.0802 7.0559 12.9716L3.9089 9.25013C3.64389 8.9334 3.74327 8.69586 4.10766 8.69586L15.0062 8.69586C15.5694 8.69586 16 8.18118 16 7.50815C16 6.83511 15.5694 6.32043 15.0062 6.32043L4.14079 6.32043C3.7764 6.32043 3.67702 6.08289 3.94203 5.76617L7.08903 2.04467C8.01656 0.936136 6.62526 -0.766253 5.69772 0.381869L0.298136 6.67675Z",
    fill: "#EF8B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackOrangeArrow);
export default __webpack_public_path__ + "static/media/back-orange-arrow.4dba1800725cfa741a38184d7789066f.svg";
export { ForwardRef as ReactComponent };